/* RideRow diagnosis-first preview (2026-10-18, GT-20261018-115834-91c756; batch 2 GT-20261018-133425-3ad038).
   Two widgets on /pages/diagnose (alternate templates, preview theme only):
     [data-rr-plan="repair"]  ?view=repair-plan  symptom -> bike -> POST /plan -> free checks + repair plan card
     [data-rr-plan="finder"]  ?view=part-finder  expert search -> GET /search -> matches / ruled out with reasons
   API base comes from the section setting (preview worker). All API text is written with textContent.
   Batch 2: follow-up questions come from the API (only symptoms that need them); free checks are numbered, multimeter tests
   fold into "For experienced DIYers"; one phrase for photos ("Send photos for a free fit check"); brake cut-off sensors are one
   checkbox (on by default, can be removed, warning when removed); search shows Add to cart + check note, ruled-out parts folded.
   Batch 3 (GT-20261018-151250-6d6271): plans that need a photo check get one main button "Get my fit check & quote", three
   plain steps (send photos -> we confirm -> you pay, we ship) and a secondary "buy it directly" link to the spec search marked
   "We check fit before shipping" (decision card rrdiag Q6 A: photo-check plans are paid only after the photos; Q2 A: experts
   may add to cart from the spec search); blocked (red) plans get a friendly heading and no photo list; four jargon terms show
   their plain-words label (param_plain); step 2 has a model search that also knows aliases ("RadRover 5").
   Batch 5 (GT-20261019-095405-2b317d, plan card): "Buy it directly" is a button that adds the parts selected on the card (main
   part per the chosen option, extra cable, ticked safety parts) via /cart/add.js and opens the theme's cart drawer (the theme's own
   cart:lines-update event, same as its product form); why-it-fits lines use the API's plain sentence instead of "yours ... (our bike
   database), part ... (listing)"; a short glossary explains UART / SM/JST and the like; the folded DIY block gets a visible line;
   once a plan is out the send-photos box below collapses (the plan's own "Get my fit check & quote" carries the photo list);
   the safety block is split into "Included parts" and "We also check".
   Batch 5 (spec search): "We read:" only when the API read some specs (a bike name read nothing and showed an empty label); a bike-name
   search gets "Start a diagnosis for this bike" that opens the plan with that bike picked in step 2 (?bike= also takes a model name such
   as "RadRover 5"); matches that differ from the search (18 A for a 22 A search) say so; "To confirm" lists plain short names.
   Batch 6 (GT-20261019-122014-36d641): every cart line added from the plan card ("Buy it directly", "Add plan to cart") carries a
   visible line property "Matches your repair plan: <part name on the plan> (bike: <bike>)" and a hidden "_source: buy-direct" (the
   theme's cart list hides properties that start with "_"); the spec search's Add to cart and product pages add no such marks.
   "Ruled out, and why" is folded, one row per part name with a count and the API's plain reason; parts whose power differs from
   the bike (far above it, or below it) say "Differs from your bike: ..."; "Other parts that may fit" cards list the same fit rows
   (the display-signal row is always there); a spec search that names a bike and a part offers "Build a <part> plan for <bike>".
   Batch 7 (GT-20261019-145440-98f095): the motor plan card has a motor choice (API motor_choice) and its extension cables follow the
   picked motor (API for_motors: same pin count, a male and a female plug); the cable heading says when one is needed (API hint);
   "Differs from your bike" / "Different motor plug" are small tags inside the option's own text (the theme lays labels out as
   flex rows, so a separate " - " text node showed up as a lone "-" line); motor cards show the plug difference too.
   Batch 7 (A2/A3): controller kits that come with a display say "Includes a new display - replaces your current display too" on
   the option and on the card (API includes_display); a charger search that names a bike lists chargers for its battery voltage
   first and tags the others "Differs from your bike: for 36 V batteries (your bike 48 V)" (API differs_bike on the match).
   Batch 7 (A4): the folded "Ruled out, and why" title counts parts and kinds - "(29 parts in 12 kinds)" - from rejected_groups.
   Batch 8 (GT-20261019-184659-884a93): plan options lead with a short label that shows what differs (API short: "500 W · 9-pin ·
   for 26 in wheels · cassette"), the full title goes on a second line, and "we check the fit" is said once per group instead of on
   every option; a group can carry a note (API note: all motors listed are bare motors) and the cable group a which-direction line
   (API direction_hint); motor cards say "Bare motor - no rim, spokes or tire" (API build_note); "Ruled out, and why" is grouped by
   reason - "(32 parts, 4 reasons)" - from rejected_by_reason (a part with two reasons is listed under both). Older API answers keep
   the batch 7 layout.
   Self-check results (GT-20261019-231306-df82f0): every free check and DIY test the API gives an id gets three buttons - Pass /
   Fail / Can't test (tap again to undo; batch 9 wording) - with a one-line note under the list title and "Fail = ..." (API fail_means) on
   each step. Results go to /plan as params.self_check_results and the plan is rebuilt while the page stays on the step you tapped;
   the API's check_results show as "Based on your check results" (what failed, what is ruled out, what is next) and, when a check
   could not be done (photo_check), a photo check entry - the existing email-your-photos link plus the #send-photos box, kept
   visible. A failed step that points to something you fix yourself (recommended.found) shows the gate card as "Fix this first".
   Picking another symptom or changing the throttle answer clears the results. The "I did every check" button and
   params.self_check are unchanged.
   Direct-buy gate (GT-20261019-134835-aa5b55; Chris's decision as passed on by Grok: specs not confirmed yet -> photos first,
   then buy): the plan card shows "Add plan to cart" / "Buy it directly" only while the main part - or the option picked in the
   main-part group - is a confirmed fit (API can_add_to_cart true; an answer without the field counts as not addable); otherwise
   the one main action is "Get my fit check & quote". Picking another option checks again. In the spec search a match that is not
   a confirmed fit gets the existing "Send photos for a free fit check" email link (the email names the part) instead of Add to
   cart; confirmed fits keep Add to cart. The cart code is unchanged.
   Batch 9 (GT-20261020-095454-5b1a54): when the "Ruled out, and why" reason rows add up to more than the parts, the heading itself
   says "some parts have more than one reason, so they are listed in more than one group" (it used to be a line at the bottom of
   the opened block).
   Batch 10 (GT-20261020-135424-b175e1): self-check results are sent for every plan, not only symptom plans (the API now gives step
   ids on motor, controller and other repair plans too, so their free checks and multimeter tests get Pass / Fail / Can't test);
   a photo-check answer with candidates (no part confirmed for the plug you picked) lists all of them under "Parts that may fit";
   "Ruled out, and why" counts distinct part names (API rejected_summary / group names) and a name sold in several versions says
   "(9 versions)" instead of "(x9)".
   Batch 11 (GT-20261020-155424-302599): a tapped Pass / Fail / Can't test greys that step's buttons and says "Updating your plan..."
   until the new plan is in; then a line under that step says whether the answer changed the plan ("Your answer changed the plan: ..."
   with a "See the updated plan" link up to the top of the result, or "Your answer did not change the plan: ..."), and the page does not
   jump. A "Fix this first" card keeps the plan you had as a way out: under the fix, a folded "If it still does not run after this fix"
   lists the most likely part and its first parts (API recommended.after_fix) with the "I did every check" button inside.
   The theme scrolls inside .page-wrapper, not the window, so keeping the tapped step in place and the link both scroll that box.
   Batch 11 item 7: a motor card that costs clearly more than the other motors of its power lists how it differs from them, only
   what the maker states (API same_power_note: "How it differs from the other 750 W motors here ($242.99-$257.99)").
   Batch 11 item 8a: motor cards say where the motor cable exits when the maker states it (API cable_exit_note); no line otherwise.
   Batch 12 item 1 (GT-20261021-095323-f9eb05): under the cable heading, one line for the motor ticked above says which cables are
   listed and for which motor ("Listed: 9-pin extensions, for the 9-pin motor ticked above. Tick an 11-pin motor to see the 11-pin
   extension instead.") or, when we stock none for its plug, says so and asks for a photo (API pick_notes, keyed by motor); it
   changes with the motor picked. Older API answers keep the batch 7 line.
   Batch 12 item 3: the folded "If it still does not run after this fix" row shows a + / - sign, keeps aria-expanded in step with
   the fold (aria-controls names what it opens) and is at least 44 px high; it is still the fold's summary (Enter / Space).
   Batch 12 item 5b: with the brand set to Rad Power, a line under the brand / model pickers says how Rad tells its models apart
   (only what Rad's help article says) and links to that article.
   Batch 13 item 1 (GT-20261021-124843-eddf1c): the motor extension cable plan (step 2 failed) also asks how many pins the motor
   plug has; answering it there keeps the check results, so the plan stays on the cable and only lists that pin count.
   Batch 13 item 2: on a "Fix this first" card a line under the free fix, outside the fold, says the parts are in the fold below
   if the fix does not help (API after_fix.pointer); older API answers have no line. */
(function () {
  'use strict';

  /* i18n (GT-20261021-221141-bee374, 2026-10-21 cc10; new unpublished preview theme only - the live theme keeps its own copy):
     every customer-facing text is a key. RR_I18N_EN below is the English text byte for byte (generated from
     _i18n_impl_2026-10-21/i18n/diag_strings.json), so an English page renders exactly as before even if the dictionary asset is
     missing; Chinese, Spanish and Portuguese come from assets/rr-plan-i18n.js (window.RR_PLAN_I18N.zh / .es / .pt). The language is
     Shopify.locale (zh-CN -> zh, es -> es, pt-BR -> pt, anything else -> en). Text from the API is already in that language: the plan / search requests carry
     locale only when it is not English, so English requests are unchanged. */
  /* RR_I18N_EN_BEGIN */
  var RR_I18N_EN = {"adv.hint.one": "{n} multimeter test for when the free checks do not find the fault. Tap \"{title}\" to open it.", "adv.hint.other": "{n} multimeter tests for when the free checks do not find the fault. Tap \"{title}\" to open them.", "adv.measure": "Measure: ", "adv.normal": "Normal: ", "adv.not_normal": "If not normal: ", "adv.title": "For experienced DIYers", "bike.choose_model": "Choose your model", "bike.label_and_earlier": "{label} and earlier", "bike.no_match": "No match yet - pick your brand below, or choose \"My bike is not listed\".", "bike.not_listed": "My bike is not listed", "bike.rad_hint": "Not sure which Rad model you have? Rad Power Bikes says: \"All ebikes from 2020 and onward have a badge printed on the frame with the model name and model number\" - on the seat tube, or on the down tube if an external battery is mounted on the seat tube. Rad bikes introduced before 2020 have no model number badge; Rad tells their model year by the battery and the logo on the head tube. ", "bike.rad_link": "Rad\u2019s guide: How to identify your Rad Power Bikes model number", "bike.selected": "Selected: {x}", "busy.default": "Working on it...", "busy.plan": "Building your repair plan...", "busy.search": "Searching our parts...", "card.add_plan": "Add plan to cart", "card.brake_match": " We match the sensor to your brakes (cable or hydraulic) before you pay.", "card.buy_direct": "Buy it directly", "card.dim_check": "We check the fit of the one you pick before shipping.", "card.eyebrow": "Recommended repair plan", "card.included": "Included parts", "card.keep_safety": "We recommend keeping this safety part.", "card.know_part": "Know exactly which part you need? ", "card.no_cable": "No extra cable", "card.no_cable_stock": "We do not stock an extension cable for the plug on this motor.", "card.photo_dash": " - photo: {photo}", "card.prices_same": "Prices shown are the same as in our store.", "card.refund_note": " - if our check finds it will not fit your bike, we cancel the order and refund you in full.", "card.safety_item": " {item} - safety", "card.to_confirm": "To confirm before we ship", "card.total": "Plan total: {price}", "card.we_check": "We also check", "card.why_fits": "Why it fits your bike", "cart.add_failed": "We could not add this to your cart{why}. Please try again, or use \"{cta}\".", "cart.added_view": "Added - view cart", "cart.adding": "Adding...", "cart.bike_suffix": " (bike: {bike})", "cart.part_default": "Repair plan part", "cart.plan_prop": "Matches your repair plan", "check.busy": "Updating your plan...", "check.cant_test": "Can't test", "check.changed_line": "Your answer changed the plan: {now}. ", "check.fail": "Fail", "check.fail_means": "Fail = {x}", "check.heading": "Based on your check results", "check.note": "Tap a result for each check you do. Pass = this looks OK. Fail = you found a problem. Can't test = you could not do this check.", "check.pass": "Pass", "check.same_line": "Your answer did not change the plan: {now}. ", "check.see_plan": "See the updated plan \u2191", "check.which_photos": "Which photos to send", "component.brake_cutoff": "Brake cut-off sensors", "component.charger": "Charger", "component.controller": "Controller", "component.display": "Display", "component.harness": "Wiring harness", "component.motor": "Hub motor", "component.motor_cable": "Motor extension cable", "component.pas_sensor": "Pedal assist sensor", "component.throttle": "Throttle", "cta.check_ship": "We check fit before shipping", "cta.photo": "Send photos for a free fit check", "cta.quote": "Get my fit check & quote", "cta.red_photo": "Send photos - we look for another option", "error.generic": "Something went wrong on our side.", "error.pick_first": "Pick what is wrong first (step 1).", "error.plan_unreachable": "We could not reach the repair-plan service. Please try again in a minute.", "error.search_unreachable": "We could not reach the search service. Please try again in a minute.", "finder.add": "Add to cart", "finder.badge_fits": "Matches what you asked", "finder.differs": "Differs from your search: {list}", "finder.matches": "Matches ({n})", "finder.ruled_out_n": "{n} parts ruled out", "finder.start": "Not sure? Start a diagnosis", "finder.start_bike": "Start a diagnosis for this bike", "finder.to_confirm": "To confirm: {list}", "finder.too_short": "Type the part you need, for example: 48V 22A controller SM plug", "finder.we_read": "We read: ", "finder.you_asked": " (you asked {x})", "fit.fallback": "{param}: matches your bike ({part})", "gate.button": "I did every check - it is still not fixed", "gate.fix_first": "Fix this first", "gate.no_buy": "Do not buy a part yet", "gloss.title": "What the words on this plan mean:", "how.confirm": "We confirm the fit", "how.confirm_text": "We check your photos against this plan and email you a quote for the plan total above.", "how.pay": "You pay, we ship", "how.pay_text": "You get a secure payment link only after the fit is confirmed - nothing is charged before that.", "how.send": "Send photos", "how.send_default": "A photo of the bike and of the old part.", "light.green": "Ready to order", "light.red": "Let's find another way to fix this", "light.yellow": "Free fit check first", "mail.bike_line": "Bike: {x}", "mail.not_listed": "not listed", "mail.part_line": "Part: {name} ({price})", "mail.photo_default_line": "- a photo of the bike and of the old part", "mail.photo_subject": "Photos for a free fit check", "mail.photos_attached": "Photos attached:", "mail.plan_line": "Plan: {title} - {name}", "mail.problem_line": "Problem: {x}", "mail.quote_subject": "Fit check & quote: {x}", "mail.repair_plan": "repair plan", "next.default": "Next step", "next.red": "What you can do next", "now.fix_first": "fix this first - {part}", "now.fix_first_still": "still fix this first - {part}", "now.free_checks": "do the free checks first", "now.free_checks_still": "still do the free checks first", "now.likely_now": "the most likely part is now the {part}", "now.likely_still": "the most likely part is still the {part}", "now.suggest": "we now suggest {name}", "photo.pic_axle": "Axle end, close up", "photo.pic_battery_label": "Battery label (or charger label)", "photo.pic_battery_mount": "Battery mount", "photo.pic_bb": "Bottom bracket", "photo.pic_bike_side": "Whole bike from the side", "photo.pic_brake": "Brakes", "photo.pic_brake_lever": "Brake levers and their plugs", "photo.pic_controller": "Controller label and its plugs", "photo.pic_display": "Display, face on, and its back label", "photo.pic_drivetrain": "Rear gears, close up", "photo.pic_dropout_ruler": "Rear dropout with a tape measure across it", "photo.pic_light": "Headlight and its label", "photo.pic_motor_plug": "Motor plug, face on, next to a ruler", "photo.pic_nameplate": "Motor nameplate", "photo.pic_pas": "Pedal sensor at the cranks", "photo.pic_tire_sidewall": "Tire sidewall writing", "photo.pic_wheel": "Wheel and spokes", "picked.problem": "Problem: {x}", "picked.repair": "Repair: {x}", "pin.help": "Count the pins (or holes) on the face of the plug, not the wires behind it.", "pin.help_link": "How to count them, with photos", "plan.after_fix": "If it still does not run after this fix", "plan.brake_item": "Brake cut-off sensors", "plan.brake_warn": "Without brake cut-off sensors the motor keeps pushing while you brake. We strongly recommend keeping them.", "plan.free_checks": "Try these free checks first", "plan.lock_heading": "Most likely part", "plan.more_parts.one": "+ {n} more part in the full plan.", "plan.more_parts.other": "+ {n} more parts in the full plan.", "plan.not_stated": "not stated", "plan.nothing": "nothing", "plan.other_parts": "Other parts that may fit", "plan.other_ways": "Other ways to fix it", "plan.parts_may_fit": "Parts that may fit", "plan.photo_suffix": " (photo: {photo})", "plan.photos_needed": "Photos we still need", "plan.to_confirm_line": "To confirm: {list}", "plan.why_may_fit": "Why it may fit:", "plan.why_may_fit_none": "Why it may fit: nothing confirmed yet", "ruled.head_kinds": "Ruled out, and why ({parts} in {kinds})", "ruled.head_reasons": "Ruled out, and why ({parts}, {reasons})", "ruled.multi_note": " - some parts have more than one reason, so they are listed in more than one group", "ruled.n_kinds.one": "{n} kind", "ruled.n_kinds.other": "{n} kinds", "ruled.n_parts.one": "{n} part", "ruled.n_parts.other": "{n} parts", "ruled.n_reasons.one": "{n} reason", "ruled.n_reasons.other": "{n} reasons", "ruled.versions": " ({n} versions)"};
  /* RR_I18N_EN_END */
  var RR_I18N = window.RR_PLAN_I18N || {};
  var RR_LOC = String((window.Shopify && window.Shopify.locale) || document.documentElement.getAttribute('lang') || 'en').toLowerCase();
  var LANG = RR_LOC.indexOf('zh') === 0 ? 'zh' : (RR_LOC.indexOf('es') === 0 ? 'es' : (RR_LOC.indexOf('pt') === 0 ? 'pt' : 'en'));
  if (LANG !== 'en' && !RR_I18N[LANG]) LANG = 'en';          /* no dictionary for that language: stay English everywhere */
  function T(k, v) {
    var d = LANG === 'en' ? RR_I18N_EN : RR_I18N[LANG], s = d[k];
    if (s === undefined || s === null) s = RR_I18N_EN[k];
    if (s === undefined || s === null) s = k;
    if (v) s = s.replace(/\{(\w+)\}/g, function (m, n) { return v[n] !== undefined && v[n] !== null ? String(v[n]) : m; });
    return s;
  }
  function TN(k, n, v) { var o = v || {}; o.n = n; return T(k + (n === 1 ? '.one' : '.other'), o); }
  function bikeLabel(l) {                                      /* "RadRover 5 and earlier": the model name stays, the words translate */
    var s = String(l || ''), m = LANG === 'en' ? null : /^(.*\S)\s+and earlier$/.exec(s);   /* English: the label exactly as given */
    return m ? T('bike.label_and_earlier', { label: m[1] }) : s;
  }

  var PHOTO = {
    pic_battery_label: T('photo.pic_battery_label'), pic_display: T('photo.pic_display'),
    pic_controller: T('photo.pic_controller'), pic_motor_plug: T('photo.pic_motor_plug'),
    pic_bike_side: T('photo.pic_bike_side'), pic_dropout_ruler: T('photo.pic_dropout_ruler'),
    pic_axle: T('photo.pic_axle'), pic_drivetrain: T('photo.pic_drivetrain'), pic_brake: T('photo.pic_brake'),
    pic_tire_sidewall: T('photo.pic_tire_sidewall'), pic_pas: T('photo.pic_pas'), pic_brake_lever: T('photo.pic_brake_lever'),
    pic_bb: T('photo.pic_bb'), pic_light: T('photo.pic_light'), pic_battery_mount: T('photo.pic_battery_mount'), pic_wheel: T('photo.pic_wheel'),
    pic_nameplate: T('photo.pic_nameplate')
  };
  var PHOTO_CTA = T('cta.photo');
  var LIGHT = { green: T('light.green'), yellow: T('light.yellow'), red: T('light.red') };
  var QUOTE_CTA = T('cta.quote');
  var CHECK_SHIP = T('cta.check_ship');
  var RED_PHOTO_CTA = T('cta.red_photo');
  var BIKE_ALIASES = { 'Rad Power|RadRover 5 \u53ca\u4ee5\u524d': ['RadRover 5'] };   /* same list as rrplan.py BIKE_ALIASES */
  var COMPONENT_REPAIR = { controller: 'controller', display: 'display', motor: 'motor', harness: 'harness', charger: 'charger',
    throttle: 'throttle', pas_sensor: 'pas_sensor', brake_cutoff: 'brake_cutoff', motor_cable: 'motor_cable' };
  var COMPONENT_LABEL = { controller: T('component.controller'), display: T('component.display'), motor: T('component.motor'),
    harness: T('component.harness'), charger: T('component.charger'), throttle: T('component.throttle'),
    pas_sensor: T('component.pas_sensor'), brake_cutoff: T('component.brake_cutoff'), motor_cable: T('component.motor_cable') };
  /* F1104-1232hv (newcomer walk R1): the photo-check and quote buttons open our own request page (photo upload, request number, report
     page) instead of an email app - on a phone without a mail app the email buttons did nothing. The plan lines go into the page's
     message box (?note=, read by rr-diag-request.js). Email stays as a small link in the send-photos box. */
  var PHOTO_FORM = String((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/') + 'pages/diagnosis-request';
  function formHref(lines) { return PHOTO_FORM + (lines && lines.length ? '?note=' + encodeURIComponent(lines.join('\n').slice(0, 1800)) : ''); }
  var BRAKE_ITEM = 'Brake cut-off sensors', BRAKE_ITEM_L = T('plan.brake_item');   /* the API sends the item name in the page language */
  function isBrakeItem(x) { return x === BRAKE_ITEM || x === BRAKE_ITEM_L; }
  var NOT_STATED_L = T('plan.not_stated');                   /* the API's "not stated" value in the page language */
  var BRAKE_WARN = T('plan.brake_warn');
  var PLAN_PROP = T('cart.plan_prop');          /* batch 6: cart line properties from the plan card */
  var SOURCE_PROP = '_source', SOURCE_BUY = 'buy-direct';
  /* batch 9 item 6: button words shortened to Pass / Fail / Can't test (the batch 8 words were longer, past tense); the note and
     the "Fail = ..." line under each step use the same words */
  var CHECK_RESULTS = [['pass', T('check.pass')], ['fail', T('check.fail')], ['cant_test', T('check.cant_test')]];   /* self-check results */
  var CHECK_NOTE = T('check.note');
  var CHECK_HEADING = T('check.heading');
  var CHECK_BUSY = T('check.busy');            /* batch 11 item 1 */
  /* batch 11 item 2: "Your answer changed the plan: ..." / "Your answer did not change the plan: ..." (keys check.changed_line / check.same_line) */
  var SEE_PLAN = T('check.see_plan');
  /* batch 14 item 5: under the motor plug question (motor, controller and extension cable plans) one line on how to count the pins,
     linking the existing plug guide page (its "How many pins?" part has photos of male / female 9-pin plugs) - no new picture */
  var PIN_HELP = T('pin.help');
  var PIN_HELP_LINK = T('pin.help_link');
  var PLUG_GUIDE = '/pages/plug-guide';
  var AFTER_FIX = T('plan.after_fix');   /* batch 11 item 3 (API after_fix.heading) */
  var foldSeq = 0;                                              /* batch 12 item 3: ids for aria-controls */
  /* batch 12 item 5b: under the brand / model pickers, when the brand is Rad Power, how Rad itself says to tell its models apart -
     only what Rad's help article "How to identify your Rad Power Bikes model number" says (checked 2026-10-21), with a link to it */
  var RAD_BRAND = 'Rad Power';
  var RAD_ID_HINT = T('bike.rad_hint');
  var RAD_ID_SRC = 'https://www.radpowerbikes.com/pages/support?a=How-to-identify-your-Rad-Power-Bikes-model-number---id--dDzTcI5RRpibqekiyCnw5Q';
  var RAD_ID_LINK = T('bike.rad_link');

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text !== undefined && text !== null) e.textContent = String(text);
    return e;
  }
  /* rrphase2 q4 A (2026-10-23 cc31): the API adds safety_notice when the picked bike (or the search) matches an official stop-use
     battery warning (truth database kb/safety_notices.json). Every word comes from the API (translated there); battery_labels are the
     model numbers exactly as printed on the battery label. No notice in the answer = nothing changes on the page. */
  function safetyBox(sn) {
    var box = el('div', 'rr-plan__safety');
    box.setAttribute('role', 'alert');
    box.setAttribute('data-rr-safety', sn.id || '');
    box.appendChild(el('strong', null, sn.title));
    if (sn.text) box.appendChild(el('p', null, sn.text));
    if (sn.battery_labels) {
      var lab = el('p', 'rr-plan__safetylabels', sn.labels_intro ? sn.labels_intro + ' ' : '');
      lab.appendChild(el('b', null, sn.battery_labels));
      box.appendChild(lab);
    }
    if (sn.source) box.appendChild(el('p', 'rr-plan__muted', sn.source));
    return box;
  }
  function money(v) { return '$' + Number(v || 0).toFixed(2); }
  function qs(name) { try { return new URLSearchParams(window.location.search).get(name) || ''; } catch (e) { return ''; } }
  function api(root) { return (root.getAttribute('data-api-base') || '').replace(/\/+$/, ''); }
  /* batch 11: the theme scrolls inside .page-wrapper (html and body are overflow: hidden), so window.scrollBy / scrollTo do nothing
     there - the batch 9 "keep the tapped step where it is" never moved the page. Scroll the nearest scrolling box instead. */
  function scrollBox(n) {
    for (var e = n && n.parentElement; e && e !== document.body && e !== document.documentElement; e = e.parentElement) {
      var oy = window.getComputedStyle(e).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && e.scrollHeight > e.clientHeight) return e;
    }
    return null;
  }
  function scrollPage(n, dy, smooth) {
    var s = scrollBox(n) || document.scrollingElement || document.documentElement;
    if (smooth && s.scrollTo) { s.scrollTo({ top: s.scrollTop + dy, behavior: 'smooth' }); return; }
    var was = s.style.scrollBehavior;
    s.style.scrollBehavior = 'auto';               /* the theme sets scroll-behavior: smooth; keeping a step in place must not glide */
    s.scrollTop += dy;
    s.style.scrollBehavior = was;
  }
  function setBusy(box, on, msg) {
    box.textContent = '';
    if (on) box.appendChild(el('p', 'rr-plan__busy', msg || T('busy.default')));
  }
  function photoMail(m) {                /* direct-buy gate: the spec-search photo check email names the part and the photos */
    var photos = [];
    (m.to_confirm || []).forEach(function (t) {
      var nm = t.photo_slot ? (PHOTO[t.photo_slot] || t.photo_slot) : '';
      if (nm && photos.indexOf(nm) < 0) photos.push(nm);
    });
    var lines = [T('mail.part_line', { name: m.name || '', price: money(m.price) }), '', T('mail.photos_attached')]
      .concat(photos.length ? photos.map(function (x) { return '- ' + x; }) : [T('mail.photo_default_line')]);
    return formHref(lines);
  }
  function photoButton(cls) {
    var a = el('a', cls || 'rr-plan__btn', PHOTO_CTA);
    a.href = PHOTO_FORM;
    return a;
  }
  function photoAsk(box, show) {          /* batch 5: the send-photos box under the result; hidden while a plan is on screen */
    var r = box && box.closest ? box.closest('[data-rr-plan]') : null;
    var a = r ? r.querySelector('[data-rr-photos-ask]') : null;
    if (a) a.hidden = !show;
  }
  function fail(box, msg) {
    box.textContent = '';
    box.appendChild(el('p', 'rr-plan__error', msg || T('error.generic')));
    box.appendChild(photoButton('rr-plan__btn rr-plan__btn--ghost'));
    photoAsk(box, true);
  }
  function listBlock(title, items, render, ordered) {
    var wrap = el('div', 'rr-plan__block');
    wrap.appendChild(el('h3', 'rr-plan__h3', title));
    var ul = el(ordered ? 'ol' : 'ul', 'rr-plan__list' + (ordered ? ' rr-plan__list--steps' : ''));
    items.forEach(function (it) { ul.appendChild(render(it)); });
    wrap.appendChild(ul);
    return wrap;
  }
  function helpLine(item) {
    return item && item.help ? el('span', 'rr-plan__help', item.help) : null;
  }
  function pname(t) { return (t && (t.param_plain || t.param)) || ''; }     /* batch 3: plain-words label for jargon terms */
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function addToCart(variantId, btn, onDone, props) {     /* batch 6: props only from the plan card (never from the spec search) */
    var item = { id: Number(variantId), quantity: 1 };
    if (props) item.properties = props;
    btn.disabled = true;
    btn.textContent = T('cart.adding');
    fetch('/cart/add.js', { method: 'POST', headers: { 'content-type': 'application/json', accept: 'application/json' },
      body: JSON.stringify({ items: [item] }) })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function () { onDone(true); })
      .catch(function () { onDone(false); });
  }
  /* batch 5: plain why-it-fits line (API field "plain"); older API answers fall back to the label and the part's value, no sources */
  function fitText(w) { return (w && w.plain) || T('fit.fallback', { param: pname(w), part: (w && w.part) || '' }); }
  function fitItem(w) {
    var li = el('li'), t = fitText(w), i = t.indexOf(': '), cw = 2, z = t.indexOf('\uff1a');   /* Chinese text uses a full-width colon */
    if (z > 0 && (i < 0 || z < i)) { i = z; cw = 1; }
    if (i > 0) { li.appendChild(el('strong', null, t.slice(0, i + 1))); li.appendChild(el('span', null, (cw === 2 ? ' ' : '') + t.slice(i + cw))); }
    else li.appendChild(el('span', null, t));
    var h = helpLine(w); if (h) li.appendChild(h);
    return li;
  }
  /* batch 6: "Differs from your bike: 1000-1500 W (your bike 750 W)" - a plain fact line, no safety claim */
  function differsBike(box, list) {
    (list || []).forEach(function (x) {
      if (!x || !x.text) return;
      var p = el('p', 'rr-plan__muted rr-plan__difbike', x.text);
      p.setAttribute('data-rr-differs-bike', '');
      box.appendChild(p);
    });
  }
  /* batch 7: "Different motor plug: 11-pin (the rest of this plan uses 9-pin)" - a fact about the plan, no conclusion about the bike */
  function differsPlan(box, list) {
    (list || []).forEach(function (x) {
      if (!x || !x.text) return;
      var p = el('p', 'rr-plan__muted rr-plan__difbike rr-plan__difplan', x.text);
      p.setAttribute('data-rr-differs-plan', '');
      box.appendChild(p);
    });
  }
  /* batch 7: "Includes a new display - replaces your current display too" on a controller kit that comes with its own display */
  function kitNote(box, text) {
    if (!text) return;
    var p = el('p', 'rr-plan__muted rr-plan__kitnote', text);
    p.setAttribute('data-rr-includes-display', '');
    box.appendChild(p);
  }
  /* batch 8: "Bare motor - no rim, spokes or tire ..." on motor cards (API build_note) */
  function buildNote(box, text) {
    if (!text) return;
    var p = el('p', 'rr-plan__muted rr-plan__buildnote', text);
    p.setAttribute('data-rr-build-note', '');
    box.appendChild(p);
  }
  function cableExit(box, text) {  /* batch 11 item 8a: where the motor cable leaves the motor (API cable_exit_note; only when the maker states it) */
    if (!text) return;
    var p = el('p', 'rr-plan__muted rr-plan__cableexit', text);
    p.setAttribute('data-rr-cable-exit', '');
    box.appendChild(p);
  }
  function samePower(box, n) {   /* batch 11 item 7: how a clearly dearer motor differs from the others of its power (API same_power_note) */
    if (!n || !n.lines || !n.lines.length) return;
    var w = el('div', 'rr-plan__samepower');
    w.setAttribute('data-rr-same-power', '');
    w.appendChild(el('p', 'rr-plan__muted', (n.heading || '') + ':'));
    var ul = el('ul', 'rr-plan__list rr-plan__list--plain');
    n.lines.forEach(function (t) { ul.appendChild(el('li', null, t)); });
    w.appendChild(ul);
    box.appendChild(w);
  }
  /* batch 7: a small tag inside the option's own text (one line; no separate "-" between the option and the tag) */
  function choiceTag(box, text, attr, cls) {
    var t = el('span', 'rr-plan__tag ' + (cls || 'rr-plan__difbike'), text);
    t.setAttribute(attr, '');
    box.appendChild(document.createTextNode(' '));
    box.appendChild(t);
  }
  function groupRejected(rows) {
    var out = [], idx = {};
    rows.forEach(function (r) {
      var g = idx[r.name];
      if (!g) { g = idx[r.name] = { name: r.name, count: 0, reasons_plain: [] }; out.push(g); }
      g.count += 1;
      (r.reasons_plain || r.reasons || []).forEach(function (x) { if (g.reasons_plain.indexOf(x) < 0) g.reasons_plain.push(x); });
    });
    return out;
  }
  function glossaryBlock(list) {
    var wrap = el('div', 'rr-plan__block rr-plan__gloss');
    wrap.setAttribute('data-rr-glossary', '');
    wrap.appendChild(el('p', 'rr-plan__muted', T('gloss.title')));
    var ul = el('ul', 'rr-plan__list rr-plan__list--plain');
    list.forEach(function (g) {
      var li = el('li', 'rr-plan__muted');
      li.appendChild(el('strong', null, g.term + ': '));
      li.appendChild(el('span', null, g.plain));
      ul.appendChild(li);
    });
    wrap.appendChild(ul);
    return wrap;
  }
  function drawerEl() {
    var c = document.querySelector('cart-drawer-component');
    return c && c.closest ? c.closest('theme-drawer') : null;
  }
  function openDrawer() {
    var d = drawerEl();
    if (d && typeof d.open === 'function') { if (!d.isOpen) d.open(); return true; }
    return false;
  }
  /* batch 5: add several lines and let the theme open its cart drawer. The theme's drawer and cart list listen for the standard
     cart:lines-update event (action "add" + a promise resolved with the new cart and section HTML) - the same event its product
     form sends - so the drawer opens with the new lines in it. The event class comes from window.RRCartEvents, set by a small
     inline module in sections/rr-repair-plan.liquid: Shopify's asset pipeline rewrites a dynamic module import in assets/*.js
     into require, which does not exist in the browser. Without it (or without a drawer) we go to /cart. */
  function addLines(lines, btn, onDone) {
    var secIds = [].map.call(document.querySelectorAll('cart-items-component[data-section-id]'),
      function (x) { return x.getAttribute('data-section-id'); });
    var n = lines.reduce(function (a, l) { return a + l.quantity; }, 0);
    var Ev = window.RRCartEvents, deferred = null;
    btn.disabled = true;
    btn.textContent = T('cart.adding');
    if (Ev && Ev.createPromise && drawerEl()) {
      deferred = Ev.createPromise();
      btn.dispatchEvent(new Ev({ action: 'add', context: 'product', promise: deferred.promise,
        lines: lines.map(function (l) { return { merchandiseId: String(l.id), quantity: l.quantity }; }) }));
    }
    fetch('/cart/add.js', { method: 'POST', headers: { 'content-type': 'application/json', accept: 'application/json' },
      body: JSON.stringify({ items: lines, sections: secIds.join(',') }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        return fetch('/cart.js', { headers: { accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          if (deferred) {
            deferred.resolve({ cart: Ev.createCartFromAjaxResponse(cart),
              detail: { items: cart.items, source: 'rr-plan', itemCount: n, sections: res.ok ? res.j.sections : undefined, didError: !res.ok } });
          }
          if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'cart');
          if (!deferred) { window.location.href = '/cart'; return; }      /* no event class or no drawer: the drawer would not refresh */
          setTimeout(function () { var d = drawerEl(); if (d && !d.isOpen) openDrawer(); }, 1200);
          onDone(true);
        });
      })
      .catch(function (e) {
        if (deferred) deferred.resolve({ cart: null, detail: { didError: true, source: 'rr-plan' } });
        onDone(false, e && e.message !== 'cart' ? e.message : '');
      });
  }

  /* ---------------- repair plan ---------------- */
  function initRepair(root) {
    var state = { symptom: qs('symptom').toUpperCase(), component: qs('component'), bike: qs('bike'), volt: '', checks: '', answers: {},
      results: {}, advOpen: false };
    var stepBike = root.querySelector('[data-step="bike"]');
    var out = root.querySelector('[data-rr-result]');
    var go = root.querySelector('[data-rr-go]');
    var brandSel = root.querySelector('[data-rr-brand]');
    var modelSel = root.querySelector('[data-rr-model]');
    var voltSel = root.querySelector('[data-rr-volt]');
    var picked = root.querySelector('[data-rr-picked]');
    var bikes = ((window.RR_FIT_DATA || {}).bikes || []).slice();

    function showPicked() {
      picked.textContent = state.component && COMPONENT_REPAIR[state.component]
        ? T('picked.repair', { x: COMPONENT_LABEL[state.component] || state.component })
        : (state.symptom ? T('picked.problem', { x: (root.querySelector('[data-symptom="' + state.symptom + '"]') || {}).textContent }) : '');
    }
    root.querySelectorAll('[data-symptom]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.symptom = b.getAttribute('data-symptom');
        state.component = '';
        state.answers = {};
        state.checks = '';
        state.results = {};
        state.advOpen = false;
        root.querySelectorAll('[data-symptom]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        showPicked();
        stepBike.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    var brands = [];
    bikes.forEach(function (b) { if (brands.indexOf(b.brand) < 0) brands.push(b.brand); });
    brands.sort().forEach(function (br) { var o = el('option', null, br); o.value = br; brandSel.appendChild(o); });
    var none = el('option', null, T('bike.not_listed')); none.value = '__none__'; brandSel.appendChild(none);
    var radHint = el('p', 'rr-plan__muted');                  /* batch 12 item 5b */
    radHint.setAttribute('data-rr-bike-id-hint', '');
    radHint.appendChild(document.createTextNode(RAD_ID_HINT));
    var radLink = el('a', null, RAD_ID_LINK);
    radLink.href = RAD_ID_SRC;
    radLink.target = '_blank';
    radLink.rel = 'noopener';
    radLink.style.textDecoration = 'underline';
    radHint.appendChild(radLink);
    modelSel.parentNode.parentNode.insertBefore(radHint, modelSel.parentNode.nextSibling);
    function showRadHint() {
      var on = brandSel.value === RAD_BRAND;
      radHint.hidden = !on;
      radHint.style.display = on ? '' : 'none';        /* .rr-plan__muted is a block in the theme */
    }
    function fillModels() {
      showRadHint();
      modelSel.textContent = '';
      var first = el('option', null, T('bike.choose_model')); first.value = ''; modelSel.appendChild(first);
      bikes.filter(function (b) { return b.brand === brandSel.value; }).forEach(function (b) {
        var o = el('option', null, bikeLabel(b.label) + (b.years && b.years !== '-' ? ' (' + b.years + ')' : '')); o.value = b.key; modelSel.appendChild(o);
      });
      modelSel.disabled = brandSel.value === '' || brandSel.value === '__none__';
      root.querySelector('[data-rr-volt-row]').hidden = brandSel.value !== '__none__';
    }
    var bikeQ = root.querySelector('[data-rr-bike-q]');
    var bikeHits = root.querySelector('[data-rr-bike-hits]');
    function bikeText(b) { return b.brand + ' ' + bikeLabel(b.label) + (b.years && b.years !== '-' ? ' (' + b.years + ')' : ''); }
    /* batch 6: the bike named in the cart line property - the bike picked in step 2, else the API's own label, else none */
    function bikeName(d) {
      var b = bikes.filter(function (x) { return x.key === state.bike; })[0];
      return b ? b.brand + ' ' + bikeLabel(b.label) : ((d && d.input && d.input.bike) || '');
    }
    function planProps(name, d) {
      var p = {}, bk = bikeName(d);
      p[PLAN_PROP] = (name || T('cart.part_default')) + (bk ? T('cart.bike_suffix', { bike: bk }) : '');
      p[SOURCE_PROP] = SOURCE_BUY;
      return p;
    }
    function bikeNames(b) {
      var short = String(b.label || '').replace(/\s+and\s+(earlier|later|newer|older)$/i, '');
      return [b.brand + ' ' + b.label, b.label, short, b.brand + ' ' + short].concat(BIKE_ALIASES[b.key] || []).map(norm);
    }
    function findBikes(q) {
      var n = norm(q), exact = [], part = [];
      if (n.length < 3) return [];
      bikes.forEach(function (b) {
        var ns = bikeNames(b);
        if (ns.indexOf(n) >= 0) exact.push(b);
        else if (ns.some(function (x) { return x.indexOf(n) >= 0; })) part.push(b);
      });
      return exact.concat(part).slice(0, 6);
    }
    function pickBike(b) {
      brandSel.value = b.brand; fillModels(); modelSel.value = b.key; state.bike = b.key;
      bikeQ.value = bikeText(b);
      bikeHits.textContent = '';
      bikeHits.appendChild(el('p', 'rr-plan__muted', T('bike.selected', { x: bikeText(b) })));
    }
    if (bikeQ && bikeHits) {
      bikeQ.addEventListener('input', function () {
        bikeHits.textContent = '';
        var hits = findBikes(bikeQ.value);
        if (!hits.length) {
          if (norm(bikeQ.value).length >= 3) bikeHits.appendChild(el('p', 'rr-plan__muted', T('bike.no_match')));
          return;
        }
        var box = el('div', 'rr-plan__chips');
        hits.forEach(function (b) {
          var bt = el('button', 'rr-plan__chip rr-plan__bikehit', bikeText(b)); bt.type = 'button';
          bt.setAttribute('data-rr-bike-hit', b.key);
          bt.addEventListener('click', function () { pickBike(b); });
          box.appendChild(bt);
        });
        bikeHits.appendChild(box);
      });
    }
    brandSel.addEventListener('change', function () { state.bike = ''; fillModels(); });
    modelSel.addEventListener('change', function () { state.bike = modelSel.value; });
    voltSel.addEventListener('change', function () { state.volt = voltSel.value; });
    if (state.bike) {
      var hit = bikes.filter(function (b) { return b.key === state.bike; })[0];
      if (hit) { brandSel.value = hit.brand; fillModels(); modelSel.value = hit.key; }
      else {                                  /* batch 5: ?bike=RadRover 5 from the spec search - pick it only if the name is exact and unique */
        var named = bikes.filter(function (b) { return bikeNames(b).indexOf(norm(state.bike)) >= 0; });
        if (named.length === 1) pickBike(named[0]); else { state.bike = ''; fillModels(); }
      }
    } else { fillModels(); }
    showPicked();

    function body() {
      var b = { params: {} };
      if (state.component && COMPONENT_REPAIR[state.component]) b.repair_type = COMPONENT_REPAIR[state.component];
      if (state.symptom) b.symptom = state.symptom;
      if (state.bike) b.bike = state.bike;
      if (state.volt) b.params.battery_voltage = state.volt;
      Object.keys(state.answers).forEach(function (k) { if (state.answers[k]) b.params[k] = state.answers[k]; });
      if (state.checks) b.params.self_check = state.checks;
      var res = {};
      Object.keys(state.results).forEach(function (k) { res[k] = state.results[k]; });
      if (Object.keys(res).length) b.params.self_check_results = res;   /* batch 10: repair-type plans too */
      if (LANG !== 'en') b.locale = LANG;                            /* i18n: the API answers in the page language */
      return b;
    }
    function anchorSel(a) {                        /* F1104-1232hv: 'ask:<key>' = a follow-up question; anything else = a check step id */
      return a.indexOf('ask:') === 0 ? '[data-rr-follow-up="' + a.slice(4) + '"]' : '[data-rr-check="' + a + '"]';
    }
    function run(anchor) {
      if (!state.symptom && !state.component) { fail(out, T('error.pick_first')); return; }
      var row = typeof anchor === 'string' ? out.querySelector(anchorSel(anchor)) : null;
      var mark = row ? row.getBoundingClientRect().top : null;     /* self-check results: keep the tapped step where it is */
      if (row) checkBusy(row); else setBusy(out, true, T('busy.plan'));
      fetch(api(root) + '/plan', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body()) })
        .then(function (r) { return r.json(); })
        .then(function (d) { if (!d || d.ok === false) { fail(out, (d && d.error) || null); return; } renderPlan(d, row ? anchor : null, mark); })
        .catch(function () { fail(out, T('error.plan_unreachable')); });
    }
    go.addEventListener('click', function () { run(); });

    function followUp(d) {
      var wrap = el('div', 'rr-plan__card rr-plan__card--ask');
      d.follow_up.forEach(function (q, qi) {
        var fs = el('fieldset', 'rr-plan__ask');
        fs.setAttribute('data-rr-follow-up', q.key);
        fs.appendChild(el('legend', null, q.question));
        (q.options || []).forEach(function (o) {
          var lab = el('label', 'rr-plan__choice');
          var r = el('input'); r.type = 'radio'; r.name = 'rr-ask-' + qi; r.value = o.value;
          r.checked = (state.answers[q.key] || '') === o.value;
          r.addEventListener('change', function () {
            state.answers[q.key] = o.value;
            /* batch 13 item 1: in the motor extension cable plan (step 2 "Check the motor plug" failed) the plug answer only changes
               which cables are listed - keep the check results, or the plan would fall back to the motor plan */
            /* F1104-1232hv (newcomer walk R2): the plug answer only changes which parts match, in every plan - it never clears the
               Pass / Fail results or "I did every check" (it used to, outside the cable plan, and the whole plan fell back to "Do not buy
               a part yet"); the plan is built again with the question kept where it is on screen */
            if (q.key === 'motor_plug') { run('ask:' + q.key); return; }
            state.checks = ''; state.results = {};
            run();
          });
          lab.appendChild(r);
          lab.appendChild(el('span', null, ' ' + o.label));
          fs.appendChild(lab);
        });
        if (q.key === 'motor_plug') {              /* batch 14 item 5 */
          var how = el('p', 'rr-plan__muted');
          how.setAttribute('data-rr-pin-help', '');
          how.appendChild(document.createTextNode(PIN_HELP + ' '));
          var guide = el('a', null, PIN_HELP_LINK);
          guide.href = PLUG_GUIDE;
          guide.target = '_blank';
          guide.rel = 'noopener';
          guide.style.textDecoration = 'underline';
          how.appendChild(guide);
          fs.appendChild(how);
        }
        wrap.appendChild(fs);
      });
      return wrap;
    }

    function checkButtons(s) {                     /* self-check results: Pass / Fail / Can't test under one step */
      var row = el('div', 'rr-plan__checkbtns');
      row.setAttribute('data-rr-check', s.id);
      row.style.cssText = 'display:flex;flex-wrap:wrap;gap:8px;align-items:center;margin-top:6px';
      var cur = state.results[s.id] || '';
      CHECK_RESULTS.forEach(function (r) {
        var on = cur === r[0];
        var b = el('button', 'rr-plan__btn rr-plan__btn--small' + (on ? '' : ' rr-plan__btn--ghost'), r[1]);
        b.type = 'button';
        b.setAttribute('data-rr-check-result', r[0]);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.addEventListener('click', function () {
          if (state.results[s.id] === r[0]) delete state.results[s.id]; else state.results[s.id] = r[0];
          run(s.id);
        });
        row.appendChild(b);
      });
      if (s.fail_means) {
        var fm = el('span', 'rr-plan__muted', T('check.fail_means', { x: s.fail_means }));
        fm.setAttribute('data-rr-fail-means', '');
        row.appendChild(fm);
      }
      return row;
    }
    function checkBusy(row) {                      /* batch 11 item 1: the tapped step shows it is working (the plan used to change with no sign) */
      row.setAttribute('aria-busy', 'true');
      row.querySelectorAll('[data-rr-check-result]').forEach(function (b) {
        b.disabled = true;
        b.style.opacity = '0.45';
        b.style.cursor = 'progress';
      });
      var w = el('span', 'rr-plan__muted', CHECK_BUSY);
      w.setAttribute('data-rr-check-busy', '');
      w.setAttribute('role', 'status');
      row.insertBefore(w, row.querySelector('[data-rr-fail-means]'));
    }
    function planSig(d) {
      var rec = d.recommended || {};
      return [d.light, d.locked_component, rec.type, rec.found ? 1 : 0, rec.variant_id || ''].join('|');
    }
    function planNow(d, changed, prev) {           /* batch 11 item 2: what the plan says now, in a few words */
      var rec = d.recommended || {};
      var part = String(d.locked_label || COMPONENT_LABEL[d.locked_component] || d.locked_component || '');
      part = part.charAt(0).toLowerCase() + part.slice(1);
      if (rec.type === 'self_check_first') {
        return rec.found ? T(changed ? 'now.fix_first' : 'now.fix_first_still', { part: part })
          : T(changed ? 'now.free_checks' : 'now.free_checks_still');
      }
      if (changed && prev && prev.comp === d.locked_component && rec.name) return T('now.suggest', { name: rec.name });
      return T(changed ? 'now.likely_now' : 'now.likely_still', { part: part });
    }
    function checkOutcome(d, changed, prev) {      /* batch 11 item 2: one line under the tapped step */
      var p = el('p', null, T(changed ? 'check.changed_line' : 'check.same_line', { now: planNow(d, changed, prev) }));
      p.setAttribute('data-rr-check-outcome', changed ? 'changed' : 'same');
      p.setAttribute('role', 'status');
      p.style.cssText = 'margin:6px 0 0;padding:4px 10px;border-left:3px solid var(--acc);font-weight:600';
      if (changed) {
        var a = el('a', null, SEE_PLAN);
        a.href = '#rr-plan-top';
        a.setAttribute('data-rr-see-plan', '');
        a.style.textDecoration = 'underline';
        a.addEventListener('click', function (e) {
          var t = out.querySelector('[data-rr-plan-top]');
          if (!t) return;
          e.preventDefault();
          scrollPage(t, t.getBoundingClientRect().top - 90, true);
        });
        p.appendChild(a);
      }
      return p;
    }
    function afterFixBlock(af, again) {            /* batch 11 item 3: the plan you had, folded under the fix */
      var det = el('details', 'rr-plan__afterfix');
      det.setAttribute('data-rr-after-fix', af.locked_component || '');
      det.style.marginTop = '12px';
      /* batch 12 item 3: the closed row read like plain text - it gets a visible + / - sign (a real span), aria-expanded that
         follows the fold, aria-controls on the part it opens and a row at least 44 px high for a thumb; it stays the details'
         own summary, so Enter / Space still open it. The old line was det.appendChild(el('summary', null, af.heading || AFTER_FIX)). */
      var sum = el('summary');
      var mark = el('span', 'rr-plan__foldmark', '+');
      mark.setAttribute('data-rr-fold-mark', '');
      mark.setAttribute('aria-hidden', 'true');
      mark.style.cssText = 'display:inline-flex;align-items:center;justify-content:center;flex:0 0 auto;width:22px;height:22px;' +
        'border:1.5px solid currentColor;border-radius:50%;font-weight:700;line-height:1';
      sum.appendChild(mark);
      sum.appendChild(el('span', null, af.heading || AFTER_FIX));
      var body = el('div', 'rr-plan__afterfix-body');
      body.id = 'rr-afterfix-' + (++foldSeq);
      sum.setAttribute('aria-expanded', 'false');
      sum.setAttribute('aria-controls', body.id);
      sum.style.minHeight = '44px';
      sum.style.display = 'flex';
      sum.style.alignItems = 'center';
      sum.style.gap = '10px';
      sum.style.cursor = 'pointer';
      sum.style.fontWeight = '600';
      det.appendChild(sum);
      det.appendChild(body);
      det.addEventListener('toggle', function () {
        sum.setAttribute('aria-expanded', det.open ? 'true' : 'false');
        mark.textContent = det.open ? '\u2212' : '+';
      });
      if (af.text) body.appendChild(el('p', null, af.text));
      if (af.parts && af.parts.length) {
        var ul = el('ul', 'rr-plan__list');
        af.parts.forEach(function (c) {
          var li = el('li', 'rr-plan__alt');
          li.appendChild(el('strong', null, c.name + ' - ' + money(c.price)));
          differsBike(li, c.differs_bike);
          kitNote(li, c.includes_display);
          ul.appendChild(li);
        });
        body.appendChild(ul);
        if (af.more) body.appendChild(el('p', 'rr-plan__muted', TN('plan.more_parts', af.more)));
      }
      body.appendChild(again);
      return det;
    }
    function checkResultsBlock(cr) {               /* self-check results: the "Based on your check results" box */
      var box = el('div', 'rr-plan__card');
      box.setAttribute('data-rr-check-results', '');
      box.style.border = '2px solid var(--acc)';
      box.appendChild(el('h3', 'rr-plan__h3', cr.heading || CHECK_HEADING));
      var ul = el('ul', 'rr-plan__list');
      (cr.lines && cr.lines.length ? cr.lines : [cr.text]).forEach(function (t) { if (t) ul.appendChild(el('li', null, t)); });
      box.appendChild(ul);
      if (cr.photo_check) {
        var ph = el('div', 'rr-plan__row');
        ph.setAttribute('data-rr-photo-check', '');
        ph.appendChild(photoButton('rr-plan__btn rr-plan__btn--small'));
        var how = el('a', null, T('check.which_photos'));
        how.href = '#send-photos';
        how.style.textDecoration = 'underline';
        ph.appendChild(how);
        box.appendChild(ph);
      }
      return box;
    }

    function advancedBlock(adv) {
      /* batch 5: the fold keeps its title and stays closed, but a visible line under it says what is inside (customers saw a bare
         "For experienced DIYers" with nothing under it); the line hides once the fold is opened (rr-plan.css). */
      var wrap = el('div', 'rr-plan__advwrap');
      wrap.setAttribute('data-rr-adv', '');
      var n = (adv.steps || []).length;
      var det = el('details', 'rr-plan__adv');
      if (state.advOpen) det.open = true;
      det.addEventListener('toggle', function () { state.advOpen = det.open; });
      det.appendChild(el('summary', null, adv.title || T('adv.title')));
      if (adv.text) det.appendChild(el('p', 'rr-plan__muted', adv.text));
      var ol = el('ol', 'rr-plan__list rr-plan__list--steps');
      (adv.steps || []).forEach(function (s) {
        var li = el('li', 'rr-plan__check');
        li.appendChild(el('strong', null, s.title));
        if (s.measure) { var m = el('p', null); m.appendChild(el('em', null, T('adv.measure'))); m.appendChild(document.createTextNode(s.measure)); li.appendChild(m); }
        if (s.normal) { var n = el('p', null); n.appendChild(el('em', null, T('adv.normal'))); n.appendChild(document.createTextNode(s.normal)); li.appendChild(n); }
        if (s.if_not_normal) { var x = el('p', 'rr-plan__muted'); x.appendChild(el('em', null, T('adv.not_normal'))); x.appendChild(document.createTextNode(s.if_not_normal)); li.appendChild(x); }
        if (s.id) li.appendChild(checkButtons(s));
        ol.appendChild(li);
      });
      det.appendChild(ol);
      wrap.appendChild(det);
      var hint = el('p', 'rr-plan__muted rr-plan__adv-hint', TN('adv.hint', n, { title: adv.title || T('adv.title') }));
      hint.setAttribute('data-rr-adv-hint', '');
      wrap.appendChild(hint);
      return wrap;
    }

    function renderPlan(d, anchor, mark) {
      var prev = state.lastPlan;                   /* batch 11 item 2: the plan before this answer */
      state.lastPlan = { sig: planSig(d), comp: d.locked_component };
      out.textContent = '';
      out.setAttribute('data-light', d.light || '');
      var cr = d.check_results || null;
      state.results = {};                          /* only the results the API used (unknown ids and values are dropped there) */
      if (cr && cr.results) Object.keys(cr.results).forEach(function (k) { state.results[k] = cr.results[k]; });
      out.setAttribute('data-rr-cause-order', (d.cause_order || []).map(function (c) { return c.cause; }).join(','));
      var head = el('div', 'rr-plan__light rr-plan__light--' + (d.light || 'yellow'));
      head.id = 'rr-plan-top';
      head.setAttribute('data-rr-plan-top', '');
      head.appendChild(el('strong', null, LIGHT[d.light] || d.light));
      if (d.light_reason) head.appendChild(el('p', null, d.light_reason));
      out.appendChild(head);
      if (d.safety_notice) out.appendChild(safetyBox(d.safety_notice));   /* rrphase2 q4 A */
      var lock = el('div', 'rr-plan__lock');
      lock.appendChild(el('strong', null, (d.lock_heading || T('plan.lock_heading')) + ': ' + (d.locked_label || d.locked_component)));
      if (d.lock_basis) lock.appendChild(el('p', 'rr-plan__muted', d.lock_basis));
      out.appendChild(lock);
      if (d.follow_up && d.follow_up.length) out.appendChild(followUp(d));

      if (d.self_check && d.self_check.length) {
        var checks = listBlock(T('plan.free_checks'), d.self_check, function (s) {
          var li = el('li', 'rr-plan__check');
          li.appendChild(el('strong', null, s.title));
          if (s.text) li.appendChild(el('span', null, ' ' + s.text));
          if (s.id) li.appendChild(checkButtons(s));
          return li;
        }, true);
        if (d.self_check.some(function (s) { return s.id; })) {
          var note = el('p', 'rr-plan__muted', CHECK_NOTE);
          note.setAttribute('data-rr-check-note', '');
          checks.insertBefore(note, checks.children[1]);
        }
        out.appendChild(checks);
      }
      if (d.self_check_advanced && (d.self_check_advanced.steps || []).length) out.appendChild(advancedBlock(d.self_check_advanced));
      if (cr) out.appendChild(checkResultsBlock(cr));
      var rec = d.recommended || {};
      /* batch 5: one main action. A repair plan (its "Get my fit check & quote" lists the photos) or a photo-check answer (its own
         photo button) hides the send-photos box below; the free-check gate keeps it, since no plan is out yet.
         Self-check results: a check you could not do (photo_check) keeps it too. */
      photoAsk(out, (rec.type !== 'repair_plan' && rec.type !== 'photo_check') || !!(cr && cr.photo_check));
      if (rec.type === 'self_check_first') {
        var gate = el('div', 'rr-plan__card rr-plan__card--gate');
        gate.appendChild(el('h3', 'rr-plan__h3', rec.found ? T('gate.fix_first') : T('gate.no_buy')));
        var af = rec.found ? rec.after_fix : null;   /* batch 11 item 3: the fold says what "then" said, so "then" is left out */
        gate.appendChild(el('p', null, (rec.why || '') + (af ? '' : ' ' + (rec.then || ''))));
        if (af && af.pointer) {                      /* batch 13 item 2: a line you see without opening anything - the parts are in the fold */
          var ptr = el('p', 'rr-plan__afterfix-pointer', af.pointer);
          ptr.setAttribute('data-rr-after-fix-pointer', '');
          ptr.style.fontWeight = '600';
          gate.appendChild(ptr);
        }
        var again = el('button', 'rr-plan__btn', rec.button || T('gate.button'));
        again.type = 'button';
        again.addEventListener('click', function () { state.checks = 'failed'; run(); });
        gate.appendChild(af ? afterFixBlock(af, again) : again);
        out.appendChild(gate);
      } else if (rec.type === 'repair_plan') {
        out.appendChild(planCard(d, rec));
      } else {
        var pc = el('div', 'rr-plan__card');
        pc.appendChild(el('h3', 'rr-plan__h3', d.light === 'red' ? T('next.red') : T('next.default')));
        if (rec.why) pc.appendChild(el('p', null, rec.why));
        var pb = photoButton();
        if (d.light === 'red') pb.textContent = RED_PHOTO_CTA;
        pc.appendChild(pb);
        out.appendChild(pc);
      }
      if (d.light !== 'red' && d.missing_hard_params && d.missing_hard_params.length) {   /* batch 3: blocked plans do not ask for photos */
        out.appendChild(listBlock(T('plan.photos_needed'), d.missing_hard_params, function (m) {
          var li = el('li');
          li.appendChild(el('strong', null, m.label + ': '));
          li.appendChild(el('span', null, PHOTO[m.photo_slot] || m.photo_slot));
          return li;
        }));
      }
      /* batch 10: a photo-check answer has no recommended part, so its candidates are all listed (the first one used to be dropped) */
      var others = (d.candidates || []).slice(rec.type === 'repair_plan' ? 1 : 0);
      if (others.length) {
        out.appendChild(listBlock(rec.type === 'repair_plan' ? T('plan.other_parts') : T('plan.parts_may_fit'), others, function (c) {
          var li = el('li', 'rr-plan__alt');
          li.appendChild(el('strong', null, c.name + ' - ' + money(c.price)));
          differsBike(li, c.differs_bike);
          differsPlan(li, c.differs_plan);
          kitNote(li, c.includes_display);
          buildNote(li, c.build_note);
          cableExit(li, c.cable_exit_note);
          samePower(li, c.same_power_note);
          /* batch 6: one fit row per line, the same rows on every card (API fit_lines: the display-signal row is always there,
             "Display signal: we check this" when the maker does not state it); older API answers fall back to why_fit */
          var why = c.fit_lines || (c.why_fit || []).map(fitText);
          if (why.length) {
            li.appendChild(el('p', 'rr-plan__muted', T('plan.why_may_fit')));
            var fl = el('ul', 'rr-plan__list rr-plan__list--plain rr-plan__fitlines');
            fl.setAttribute('data-rr-fit-lines', '');
            why.forEach(function (t) { fl.appendChild(fitItem({ plain: t })); });
            li.appendChild(fl);
          } else {
            li.appendChild(el('p', 'rr-plan__muted', T('plan.why_may_fit_none')));
          }
          var conf = (c.to_confirm || []).map(function (t) { return pname(t) + (t.photo_slot ? T('plan.photo_suffix', { photo: PHOTO[t.photo_slot] || t.photo_slot }) : ''); });
          li.appendChild(el('p', 'rr-plan__muted', T('plan.to_confirm_line', { list: conf.length ? conf.join('; ') : T('plan.nothing') })));
          return li;
        }));
      }
      /* batch 6: folded like the spec search's ruled-out list - one row per part name with a count, plain reasons
         ("Uses a different display signal than your bike"); older API answers are grouped here from d.rejected */
      var byReason = d.rejected_by_reason;
      if (byReason && byReason.length) {
        /* batch 8: one row per reason with the parts it rules out under it - "(32 parts, 4 reasons)"; a part that fails two checks
           is listed under both, so the reason rows can add up to more than the number of parts */
        /* batch 10 item 7: count distinct part names, the rows a customer sees (API rejected_summary.parts; older API answers: the names
           listed under the reasons) - it used to count d.rejected, one per version, so "32 parts" sat over 12 rows. Each reason row counts
           its names too (API g.names), and a name sold in several versions says "(9 versions)". */
        var seen = {};
        byReason.forEach(function (g) { (g.parts || []).forEach(function (x) { seen[x.name] = 1; }); });
        var nParts = (d.rejected_summary && d.rejected_summary.parts) || Object.keys(seen).length || (d.rejected || []).length;
        var nOf = function (g) { return g.names != null ? g.names : (g.parts ? g.parts.length : (g.count || 0)); };
        var rb = el('details', 'rr-plan__ruled rr-plan__block');
        rb.setAttribute('data-rr-ruled-plan', String(nParts));
        rb.setAttribute('data-rr-ruled-reasons', String(byReason.length));
        var rsum = el('summary'), rhead = el('span', null, T('ruled.head_reasons', { parts: TN('ruled.n_parts', nParts),
          reasons: TN('ruled.n_reasons', byReason.length) }));
        /* batch 9 item 3: when the reason rows add up to more than the parts, say why right next to the heading (it used to sit at the
           bottom of the opened block, so "46 parts, 4 reasons" with rows adding up to 70 looked wrong until you scrolled down). Heading and
           note share one span: the theme lays the summary out as flex, which would put a second child on its own line. */
        if (byReason.reduce(function (a, g) { return a + nOf(g); }, 0) > nParts) {
          var rn = el('span', 'rr-plan__muted rr-plan__ruled-note', T('ruled.multi_note'));
          rn.setAttribute('data-rr-ruled-note', '');
          rn.style.display = 'inline';                  /* .rr-plan__muted is a block in the theme */
          rhead.appendChild(rn);
        }
        rsum.appendChild(rhead);
        rb.appendChild(rsum);
        var rlist = el('ul', 'rr-plan__list rr-plan__ruledreasons');
        byReason.forEach(function (g) {
          var li = el('li');
          var gn = nOf(g);
          li.appendChild(el('strong', null, g.reason + ' (' + TN('ruled.n_parts', gn) + ')'));
          var pl = el('ul', 'rr-plan__list rr-plan__list--plain rr-plan__ruledparts');
          (g.parts || []).forEach(function (x) { pl.appendChild(el('li', null, x.name + (x.count > 1 ? T('ruled.versions', { n: x.count }) : ''))); });
          li.appendChild(pl);
          rlist.appendChild(li);
        });
        rb.appendChild(rlist);
        out.appendChild(rb);
      }
      var groups = d.rejected_groups || groupRejected(d.rejected || []);
      if (byReason && byReason.length) groups = [];      /* batch 8: already listed above, grouped by reason */
      if (groups.length) {
        var nOut = groups.reduce(function (a, g) { return a + (g.count || 1); }, 0);
        var ruled = el('details', 'rr-plan__ruled rr-plan__block');
        ruled.setAttribute('data-rr-ruled-plan', String(nOut));
        /* batch 7: say how many parts and how many kinds (29 parts fold into 12 rows - "29 parts in 12 kinds" so nobody thinks rows are missing) */
        var nKinds = groups.length;
        ruled.setAttribute('data-rr-ruled-kinds', String(nKinds));
        ruled.appendChild(el('summary', null, T('ruled.head_kinds', { parts: TN('ruled.n_parts', nOut), kinds: TN('ruled.n_kinds', nKinds) })));
        var rl = el('ul', 'rr-plan__list');
        groups.forEach(function (g) {
          var li = el('li');
          li.appendChild(el('strong', null, g.name + (g.count > 1 ? ' (x' + g.count + ')' : '') + ': '));
          li.appendChild(el('span', null, (g.reasons_plain || []).join('; ')));
          rl.appendChild(li);
        });
        ruled.appendChild(rl);
        out.appendChild(ruled);
      }
      if (d.alternative_plans && d.alternative_plans.length) {
        out.appendChild(listBlock(T('plan.other_ways'), d.alternative_plans, function (a) {
          var li = el('li');
          li.appendChild(el('strong', null, a.title + ': '));
          li.appendChild(el('span', null, a.why));
          return li;
        }));
      }
      if (!out.querySelector('[data-rr-glossary]') && d.glossary && d.glossary.length) out.appendChild(glossaryBlock(d.glossary));
      var back = anchor ? out.querySelector(anchorSel(anchor)) : null;
      var askBack = !!anchor && anchor.indexOf('ask:') === 0;      /* F1104-1232hv: a follow-up question, not a check step */
      var changedNow = !prev || prev.sig !== state.lastPlan.sig;
      /* batch 14 item 3: when the answer turns the plan into "Fix this first", the "Based on your check results" box already says
         which step failed and what to fix first, so the "Your answer changed the plan: fix this first - ..." line under the step is
         left out (one place, not two). The "did not change" line and every other plan keep the line. */
      var merged = changedNow && rec.type === 'self_check_first' && !!rec.found && !!cr;
      if (back && !merged && !askBack) back.parentNode.insertBefore(checkOutcome(d, !prev || prev.sig !== state.lastPlan.sig, prev), back.nextSibling);
      if (back && mark !== null && mark !== undefined) scrollPage(back, back.getBoundingClientRect().top - mark, false);
      else out.scrollIntoView({ behavior: 'smooth', block: 'start' });
      /* batch 14 item 4: a Fail that changes the plan glides up to the new plan's top (the same spot "See the updated plan" jumps
         to); the new plan used to sit out of sight above the step. Other answers keep the step where it was. */
      var planTop = back && changedNow && state.results[anchor] === 'fail' ? out.querySelector('[data-rr-plan-top]') : null;
      if (planTop) scrollPage(planTop, planTop.getBoundingClientRect().top - 90, true);
    }

    function planCard(d, rec) {
      var best = (d.candidates || [])[0] || {};
      var card = el('div', 'rr-plan__card rr-plan__card--plan');
      card.setAttribute('data-rr-plan-card', '');
      card.appendChild(el('p', 'rr-plan__eyebrow', T('card.eyebrow')));
      card.appendChild(el('h3', 'rr-plan__h3', rec.title));
      var main = el('div', 'rr-plan__line');
      main.appendChild(el('span', null, rec.name));
      main.appendChild(el('strong', null, money(rec.price)));
      card.appendChild(main);
      differsBike(card, rec.differs_bike);                 /* batch 6: only when even the best part differs from the bike */
      kitNote(card, rec.includes_display);
      buildNote(card, rec.build_note);
      cableExit(card, rec.cable_exit_note);
      samePower(card, rec.same_power_note);
      if (best.why_fit && best.why_fit.length) {
        card.appendChild(listBlock(T('card.why_fits'), best.why_fit, fitItem));
      }
      if (best.to_confirm && best.to_confirm.length) {
        card.appendChild(listBlock(T('card.to_confirm'), best.to_confirm, function (t) {
          var li = el('li');
          li.appendChild(el('strong', null, pname(t) + ': '));
          li.appendChild(el('span', null, t.why + (t.photo_slot ? T('card.photo_dash', { photo: PHOTO[t.photo_slot] || t.photo_slot }) : '')));
          var h = helpLine(t); if (h) li.appendChild(h);
          return li;
        }));
      }
      /* 计价：主件价（替换型维度可换主件）+ 选中的可选安全件（断电刹把，一个复选框）+ 必含项 + 附加件（线长） */
      var dims = (d.option_dimensions || []).filter(function (x) { return x.dim !== 'brake_cutoff'; });
      var extras = [], picks = [], buyBtn = null, buyGate = null;
      var total = el('strong', 'rr-plan__total');
      function recalc() {
        var main = Number(rec.price || 0), sum = 0;
        picks.forEach(function (p) { var c = p.get(); if (!c) return; if (p.mode === 'main') main = Number(c.price || 0); else sum += Number(c.price || 0); });
        extras.forEach(function (x) { if (x.on()) sum += Number(x.price || 0); });
        total.textContent = T('card.total', { price: money(main + sum) });
        if (buyBtn) {                                     /* batch 5: the direct-buy button always adds what is selected now */
          buyBtn.setAttribute('data-rr-lines', JSON.stringify(selectedLines()));
          buyBtn.setAttribute('data-rr-line-props', JSON.stringify(cartLines().map(function (l) { return l.properties; })));
          if (buyBtn.getAttribute('data-rr-added') === '1') { buyBtn.removeAttribute('data-rr-added'); buyBtn.textContent = T('card.buy_direct'); }
        }
        if (buyGate) buyGate();                         /* direct-buy gate: the option picked in the main-part group may differ in fit */
      }
      /* batch 5: cart lines for "Buy it directly" - the main part (or the option chosen in a main-part dimension), the chosen
         extra cable, and every included or ticked safety part that is a product; checks (battery voltage) are not products */
      function selectedParts() {                          /* batch 6: [{id, name}] - name as shown on this plan card */
        var main = { id: rec.variant_id, name: rec.name }, rest = [];
        picks.forEach(function (p) {
          var c = p.get(); if (!c) return;
          if (p.mode === 'main') { if (c.variant_id) main = { id: c.variant_id, name: c.name }; }
          else if (c.variant_id) rest.push({ id: c.variant_id, name: c.name });
        });
        extras.forEach(function (x) { if (x.variant_id && x.on()) rest.push({ id: x.variant_id, name: x.name }); });
        return [main].concat(rest).filter(function (x) { return x.id; });
      }
      function selectedLines() {
        return selectedParts().map(function (x) { return { id: Number(x.id), quantity: 1 }; });
      }
      /* batch 6: the lines actually sent to /cart/add.js - each with "Matches your repair plan" and the hidden "_source" */
      function cartLines() {
        return selectedParts().map(function (x) { return { id: Number(x.id), quantity: 1, properties: planProps(x.name, d) }; });
      }
      /* batch 5: "Safety, added for you / Included: Battery voltage check" read oddly (a check is not a part). Parts go under
         "Included parts" (required ones as text, the brake cut-off sensors as one ticked box); checks go under "We also check". */
      var safety = best.safety || [];
      var isCheck = function (s) { return s.kind ? s.kind === 'check' : !s.variant_id; };
      var checks = safety.filter(isCheck);
      safety = safety.filter(function (s) { return !isCheck(s); });
      if (safety.length) {
        var wrap = el('div', 'rr-plan__block');
        wrap.setAttribute('data-rr-included', '');
        wrap.appendChild(el('h3', 'rr-plan__h3', T('card.included')));
        var ul = el('ul', 'rr-plan__list rr-plan__list--plain');
        safety.forEach(function (s) {
          var li = el('li', 'rr-plan__safety');
          if (s.required) {                                     /* 必含项：纯文字，不出灰色复选框 */
            li.appendChild(el('strong', null, s.item + (s.price ? ' (+' + money(s.price) + ')' : '')));
            li.appendChild(el('span', 'rr-plan__muted', ' - ' + (s.why || '')));
            extras.push({ price: s.price || 0, variant_id: s.variant_id, name: s.name || s.item, on: function () { return true; } });
          } else {                                              /* 可选安全件（断电刹把）：一个复选框，默认勾选，可取消，取消出风险提示 */
            var lab = el('label', 'rr-plan__optin');
            var cb = el('input'); cb.type = 'checkbox'; cb.checked = s.default !== false;
            cb.setAttribute('data-rr-safety', s.item);
            lab.appendChild(cb);
            lab.appendChild(el('strong', null, T('card.safety_item', { item: s.item }) + (s.price ? ' (+' + money(s.price) + ')' : '')));
            li.appendChild(lab);
            var note = (s.name ? s.name + '. ' : '') + (s.why || '') +
              (isBrakeItem(s.item) ? T('card.brake_match') : '');
            li.appendChild(el('p', 'rr-plan__muted', note));
            var warn = el('p', 'rr-plan__warn', isBrakeItem(s.item) ? BRAKE_WARN : T('card.keep_safety'));
            warn.setAttribute('role', 'alert');
            warn.hidden = cb.checked;
            li.appendChild(warn);
            cb.addEventListener('change', function () { warn.hidden = cb.checked; recalc(); });
            extras.push({ price: s.price || 0, variant_id: s.variant_id, name: s.name || s.item, on: function () { return cb.checked; } });
          }
          ul.appendChild(li);
        });
        wrap.appendChild(ul);
        card.appendChild(wrap);
      }
      if (checks.length) {
        var cw = el('div', 'rr-plan__block');
        cw.setAttribute('data-rr-we-check', '');
        cw.appendChild(el('h3', 'rr-plan__h3', T('card.we_check')));
        var cl = el('ul', 'rr-plan__list rr-plan__list--plain');
        checks.forEach(function (s) {
          var li = el('li', 'rr-plan__safety');
          li.appendChild(el('strong', null, String(s.item || '').replace(/\s+check$/i, '') + ': '));
          li.appendChild(el('span', 'rr-plan__muted', s.why || ''));
          if (s.price) extras.push({ price: s.price, on: function () { return true; } });
          cl.appendChild(li);
        });
        cw.appendChild(cl);
        card.appendChild(cw);
      }
      var dimRows = [];
      /* batch 7: extension cables follow the motor picked on the card - a cable with for_motors (API) shows only when the picked
         motor is in it; a hidden cable that was ticked falls back to "No extra cable". Older API answers have no for_motors. */
      function syncCables() {
        var mainRow = dimRows.filter(function (x) { return x.mode === 'main'; })[0];
        var sel = mainRow ? (mainRow.radios.filter(function (y) { return y.r.checked; })[0] || {}).c : null;
        var vid = String((sel && sel.variant_id) || rec.variant_id);
        dimRows.forEach(function (x) {
          if (x.mode !== 'addon' || !x.radios.some(function (y) { return y.c.for_motors; })) return;
          var shown = 0;
          x.radios.forEach(function (y) {
            if (y.c.none) return;
            var ok = !y.c.for_motors || y.c.for_motors.map(String).indexOf(vid) >= 0;
            y.lab.hidden = !ok;
            y.lab.style.display = ok ? '' : 'none';      /* the theme's label:has(input) display rule outranks [hidden] */
            if (!ok && y.r.checked) { y.r.checked = false; x.radios[0].r.checked = true; }
            if (ok) shown++;
          });
          /* batch 12 item 1: the line for the ticked motor (API pick_notes); it also says when we stock no cable for its plug */
          var pn = x.pickNotes ? x.pickNotes[vid] || '' : '';
          if (x.pick) { x.pick.textContent = pn; x.pick.hidden = !pn; x.pick.style.display = pn ? '' : 'none'; }
          if (x.empty) { var quiet = shown > 0 || !!pn; x.empty.hidden = quiet; x.empty.style.display = quiet ? 'none' : ''; }
        });
      }
      dims.forEach(function (dim, di) {
        var fs = el('fieldset', 'rr-plan__dim');
        fs.setAttribute('data-rr-dim', dim.dim);
        fs.appendChild(el('legend', null, dim.label));
        if (dim.hint) {                                   /* batch 7: when the extension cable is needed at all */
          var hint = el('p', 'rr-plan__muted rr-plan__dimhint', dim.hint);
          hint.setAttribute('data-rr-dim-hint', '');
          fs.appendChild(hint);
        }
        var pick = null;
        if (dim.pick_notes) {                             /* batch 12 item 1: filled in by syncCables for the ticked motor */
          pick = el('p', 'rr-plan__muted rr-plan__dimhint');
          pick.setAttribute('data-rr-cable-pick-note', '');
          pick.setAttribute('aria-live', 'polite');
          fs.appendChild(pick);
        }
        [['note', 'data-rr-dim-note'], ['direction_hint', 'data-rr-dim-direction']].forEach(function (k) {   /* batch 8 */
          if (!dim[k[0]]) return;
          var p = el('p', 'rr-plan__muted rr-plan__dimhint', dim[k[0]]);
          p.setAttribute(k[1], '');
          fs.appendChild(p);
        });
        var isMain = dim.choices.some(function (c) { return String(c.variant_id) === String(rec.variant_id); });
        var mode = isMain ? 'main' : 'addon';
        var choices = dim.choices.slice();
        if (mode === 'addon') choices.unshift({ name: T('card.no_cable'), price: 0, value: '', none: true });
        var radios = [];
        choices.forEach(function (c) {
          var lab = el('label', 'rr-plan__choice');
          var r = el('input'); r.type = 'radio'; r.name = 'rr-dim-' + di;
          r.checked = mode === 'main' ? String(c.variant_id) === String(rec.variant_id) : !!c.none;
          lab.appendChild(r);
          /* batch 5: only the parts of the value that the name does not already say (no "UART, generic-kit type, SM/JST 5-pin,
             36/48 V" after a name that says 36/48 V and SM/JST 5-pin) */
          var nn = norm(c.name), extra = (c.value && c.value !== 'not stated' && c.value !== NOT_STATED_L && String(c.name || '').indexOf(c.value) < 0)
            ? String(c.value).split(', ').filter(function (x) { return x && nn.indexOf(norm(x)) < 0; }).join(', ') : '';
          /* batch 8: a short label that shows what differs (API short), the full title on a second line; "we check the fit" is
             said once for the whole group below, not on every option */
          var txt = (c.short || ((c.name || '') + (extra ? ' - ' + extra : ''))) + (c.price ? ' (' + money(c.price) + ')' : '');
          var span = el('span', 'rr-plan__choicetext', ' ' + txt);
          /* batch 6 text, batch 7 layout: e.g. "Differs from your bike: 1000-1500 W (your bike 750 W)" as a tag in the same line */
          if (c.differs_bike) choiceTag(span, c.differs_bike, 'data-rr-differs-bike');
          if (c.differs_plan) choiceTag(span, c.differs_plan, 'data-rr-differs-plan');
          if (c.includes_display) choiceTag(span, c.includes_display, 'data-rr-includes-display', 'rr-plan__kit');
          if (c.short && c.name) span.appendChild(el('span', 'rr-plan__choicesub', c.name));
          lab.appendChild(span);
          r.addEventListener('change', function () { syncCables(); recalc(); });
          radios.push({ r: r, c: c, lab: lab });
          fs.appendChild(lab);
        });
        if (choices.some(function (c) { return c.fit === 'needs_check'; })) {   /* batch 8: once per group */
          var chk = el('p', 'rr-plan__muted rr-plan__dimcheck', T('card.dim_check'));
          chk.setAttribute('data-rr-dim-check', '');
          fs.appendChild(chk);
        }
        var row = { mode: mode, radios: radios, empty: null, pick: pick, pickNotes: dim.pick_notes || null };
        if (choices.some(function (c) { return c.for_motors; })) {
          row.empty = el('p', 'rr-plan__muted', T('card.no_cable_stock'));
          row.empty.setAttribute('data-rr-no-cable', '');
          fs.appendChild(row.empty);
        }
        dimRows.push(row);
        picks.push({ mode: mode, get: function () { var x = radios.filter(function (y) { return y.r.checked; })[0]; return x ? x.c : null; } });
        card.appendChild(fs);
      });
      syncCables();
      recalc();
      card.appendChild(total);
      var cta = el('div', 'rr-plan__cta');
      /* direct-buy gate (GT-20261019-134835-aa5b55): "Add plan to cart" / "Buy it directly" only while the main part - or the option
         picked in the main-part group - is a confirmed fit (API can_add_to_cart true; no field = not addable); otherwise the one main
         action is "Get my fit check & quote". Gated parts keep a placeholder in the CTA and are put in or taken out on every recalc. */
      function mainAddable() {
        var p = picks.filter(function (x) { return x.mode === 'main'; })[0];
        var c = p ? p.get() : null;
        return ((c && c.variant_id) ? c : rec).can_add_to_cart === true;
      }
      var gateParts = [];
      function gatedPart(node, when) {
        var mark = document.createComment(' rr-direct-buy-gate ');
        cta.appendChild(mark);
        gateParts.push({ node: node, mark: mark, when: when });
      }
      function quotePart(node) { if (d.light === 'green') gatedPart(node, false); else cta.appendChild(node); }
      if (d.light === 'green') {
        var btn = el('button', 'rr-plan__btn', T('card.add_plan')); btn.type = 'button';
        btn.setAttribute('data-rr-add-plan', '');
        btn.addEventListener('click', function () {
          addToCart(rec.variant_id, btn, function (ok) { if (ok) window.location.href = '/cart'; else { btn.disabled = false; btn.textContent = T('card.add_plan'); } },
            planProps(rec.name, d));
        });
        gatedPart(btn, true);
      }
      {                                                   /* the photo-check path: the only one when the plan is not addable */
        var photos = [];
        (d.missing_hard_params || []).concat(best.to_confirm || []).forEach(function (m) {
          var nm = m.photo_slot ? (PHOTO[m.photo_slot] || m.photo_slot) : '';
          if (nm && photos.indexOf(nm) < 0) photos.push(nm);
        });
        var quote = el('a', 'rr-plan__btn', QUOTE_CTA);
        quote.setAttribute('data-rr-quote', '');
        function quoteHref() {
          var sym = state.symptom ? (root.querySelector('[data-symptom="' + state.symptom + '"]') || {}).textContent : '';
          var lines = [T('mail.bike_line', { x: (d.input || {}).bike || T('mail.not_listed') }),
            T('mail.problem_line', { x: sym || (COMPONENT_LABEL[state.component] || state.component || '') }),
            T('mail.plan_line', { title: rec.title || '', name: rec.name || '' }), total.textContent, '',
            T('mail.photos_attached')].concat(photos.length ? photos.map(function (x) { return '- ' + x; }) : [T('mail.photo_default_line')]);
          return formHref([T('mail.quote_subject', { x: rec.title || T('mail.repair_plan') })].concat(lines));
        }
        quote.href = quoteHref();
        quote.addEventListener('click', function () { quote.href = quoteHref(); });   /* total may have changed with the options */
        quotePart(quote);
        var how = el('ol', 'rr-plan__list rr-plan__list--steps rr-plan__how');
        how.setAttribute('data-rr-quote-steps', '');
        [[T('how.send'), photos.length ? photos.join('; ') + '.' : T('how.send_default')],
         [T('how.confirm'), T('how.confirm_text')],
         [T('how.pay'), T('how.pay_text')]]
          .forEach(function (x) {
            var li = el('li', 'rr-plan__check');
            li.appendChild(el('strong', null, x[0]));
            li.appendChild(el('span', null, ' - ' + x[1]));
            how.appendChild(li);
          });
        quotePart(how);
        quotePart(el('p', 'rr-plan__muted', T('card.prices_same')));
        var direct = el('p', 'rr-plan__direct');
        direct.setAttribute('data-rr-direct', '');
        direct.appendChild(document.createTextNode(T('card.know_part')));
        /* batch 5: a real button - adds what is selected on this card to the cart and opens the cart drawer (it used to be a
           text link to the spec search). The fit-check-before-shipping promise next to it is unchanged. */
        var buy = el('button', 'rr-plan__btn rr-plan__btn--ghost rr-plan__btn--small', T('card.buy_direct'));
        buy.type = 'button';
        buy.setAttribute('data-rr-buy-direct', '');
        var buyMsg = el('span', 'rr-plan__error rr-plan__buymsg');
        buyMsg.setAttribute('role', 'status');
        buyMsg.hidden = true;
        buyBtn = buy;
        buy.setAttribute('data-rr-lines', JSON.stringify(selectedLines()));
        buy.setAttribute('data-rr-line-props', JSON.stringify(cartLines().map(function (l) { return l.properties; })));
        buy.addEventListener('click', function () {
          if (buy.getAttribute('data-rr-added') === '1') { if (!openDrawer()) window.location.href = '/cart'; return; }
          buyMsg.hidden = true;
          addLines(cartLines(), buy, function (ok, why) {
            buy.disabled = false;
            if (ok) { buy.textContent = T('cart.added_view'); buy.setAttribute('data-rr-added', '1'); return; }
            buy.textContent = T('card.buy_direct');
            buyMsg.textContent = T('cart.add_failed', { why: why ? ' (' + why + ')' : '', cta: QUOTE_CTA });
            buyMsg.hidden = false;
          });
        });
        direct.appendChild(buy);
        direct.appendChild(document.createTextNode(' '));
        direct.appendChild(el('span', 'rr-plan__checknote', CHECK_SHIP));
        direct.appendChild(document.createTextNode(T('card.refund_note')));
        direct.appendChild(buyMsg);
        if (d.light !== 'green') gatedPart(direct, true);
      }
      buyGate = function () {
        var ok = mainAddable();
        card.setAttribute('data-rr-can-buy', ok ? 'yes' : 'no');
        gateParts.forEach(function (g) {
          var on = g.when === ok;
          if (on && g.node.parentNode !== cta) cta.insertBefore(g.node, g.mark);
          else if (!on && g.node.parentNode === cta) cta.removeChild(g.node);
        });
      };
      buyGate();
      card.appendChild(cta);
      if (d.glossary && d.glossary.length) card.appendChild(glossaryBlock(d.glossary));
      return card;
    }

    if ((state.symptom || state.component) && (qs('auto') === '1')) run();
  }

  /* ---------------- part finder ---------------- */
  function initFinder(root) {
    var form = root.querySelector('[data-rr-search]');
    var input = root.querySelector('[data-rr-q]');
    var out = root.querySelector('[data-rr-result]');
    root.querySelectorAll('[data-rr-example]').forEach(function (b) {
      b.addEventListener('click', function () { input.value = b.getAttribute('data-rr-example'); search(); });
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); search(); });
    function search() {
      var q = (input.value || '').trim();
      if (q.length < 2) { fail(out, T('finder.too_short')); return; }
      setBusy(out, true, T('busy.search'));
      fetch(api(root) + '/search?q=' + encodeURIComponent(q) + (LANG !== 'en' ? '&locale=' + LANG : ''), { headers: { accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) { if (!d || d.ok === false) { fail(out, (d && d.error) || null); return; } render(d, q); })
        .catch(function () { fail(out, T('error.search_unreachable')); });
    }
    function render(d, q) {
      out.textContent = '';
      if (d.safety_notice) out.appendChild(safetyBox(d.safety_notice));   /* rrphase2 q4 A */
      var keys = Object.keys(d.parsed_params || {});
      if (keys.length) {                     /* batch 5: no empty "We read:" when nothing was read (e.g. a bike name) */
        var chips = el('div', 'rr-plan__chips');
        chips.appendChild(el('span', 'rr-plan__muted', T('finder.we_read')));
        keys.forEach(function (k) {
          var p = d.parsed_params[k];
          chips.appendChild(el('span', 'rr-plan__chip', p.label + ': ' + p.value));
        });
        out.appendChild(chips);
      }
      if (d.no_match_reason) out.appendChild(el('p', 'rr-plan__note', d.no_match_reason));
      /* batch 6: the search named a bike and a part ("RadRover 5 controller") - open that plan with both filled in */
      var bp = d.bike_plan;
      if (bp && bp.label && /^\/pages\/diagnose\?/.test(bp.url || '')) {
        var offer = el('a', 'rr-plan__btn', bp.label);
        offer.href = bp.url;
        offer.setAttribute('data-rr-bike-plan', bp.component || '');
        var ow = el('p', 'rr-plan__offer');
        ow.appendChild(offer);
        out.appendChild(ow);
      }
      if (d.matches && d.matches.length) {
        out.appendChild(listBlock(T('finder.matches', { n: d.matches.length }), d.matches, function (m) {
          var li = el('li', 'rr-plan__match');
          li.setAttribute('data-rr-match', m.variant_id || '');
          li.setAttribute('data-rr-fit', m.fit || '');
          var top = el('div', 'rr-plan__line');
          if (m.url) { var a = el('a', null, m.name); a.href = m.url; top.appendChild(a); } else { top.appendChild(el('span', null, m.name)); }
          top.appendChild(el('strong', null, money(m.price)));
          li.appendChild(top);
          if (m.fit === 'fits') li.appendChild(el('span', 'rr-plan__badge rr-plan__badge--fits', T('finder.badge_fits')));
          if (m.why_fit && m.why_fit.length) {
            li.appendChild(el('span', 'rr-plan__muted', ' ' + m.why_fit.map(function (w) { return w.param + ' ' + w.part; }).join(', ')));
          }
          if (m.differs && m.differs.length) {   /* batch 5: say where a match differs from the search (it is still within range) */
            var dif = el('p', 'rr-plan__muted rr-plan__differs', T('finder.differs', { list: m.differs.map(function (x) {
              return x.param + ' ' + x.part + T('finder.you_asked', { x: x.asked }); }).join(', ') }));
            dif.setAttribute('data-rr-differs', '');
            li.appendChild(dif);
          }
          /* batch 7: the search named a bike ("RadRover 5 charger") - a match that does not suit that bike says so */
          (m.differs_bike || []).forEach(function (x) {
            if (!x || !x.text) return;
            var db = el('p', 'rr-plan__muted rr-plan__difbike', x.text);
            db.setAttribute('data-rr-differs-bike', '');
            li.appendChild(db);
          });
          if (m.to_confirm && m.to_confirm.length) {
            li.appendChild(el('p', 'rr-plan__muted', T('finder.to_confirm', { list: m.to_confirm.map(function (t) { return t.label_plain || t.param; }).join(', ') })));
            m.to_confirm.forEach(function (t) { var h = helpLine(t); if (h) { h.textContent = (t.label_plain || t.param) + ': ' + t.help; li.appendChild(h); } });
          }
          if (m.can_add_to_cart && m.variant_id) {
            var buy = el('div', 'rr-plan__buy');
            var btn = el('button', 'rr-plan__btn rr-plan__btn--small', T('finder.add')); btn.type = 'button';
            btn.setAttribute('data-rr-add', m.variant_id);
            btn.addEventListener('click', function () {
              addToCart(m.variant_id, btn, function (ok) {
                btn.disabled = false;
                btn.textContent = ok ? T('cart.added_view') : T('finder.add');
                if (ok) btn.onclick = function () { window.location.href = '/cart'; };
              });
            });
            buy.appendChild(btn);
            if (m.check_note) buy.appendChild(el('span', 'rr-plan__checknote', m.check_note));
            li.appendChild(buy);
          } else if (m.variant_id) {
            /* direct-buy gate: a match with a spec not confirmed yet (needs_check, or an answer without can_add_to_cart) gets the
               photo check entry instead of Add to cart - send photos, we confirm the fit, then a payment link */
            var pc = el('div', 'rr-plan__buy');
            var pa = el('a', 'rr-plan__btn rr-plan__btn--small', PHOTO_CTA);
            pa.setAttribute('data-rr-photo-check', m.variant_id);
            pa.href = photoMail(m);
            pc.appendChild(pa);
            if (m.check_note) pc.appendChild(el('span', 'rr-plan__checknote', m.check_note));
            li.appendChild(pc);
          }
          return li;
        }));
      }
      if (d.rejects && d.rejects.length) {
        var det = el('details', 'rr-plan__ruled');
        det.setAttribute('data-rr-ruled-out', String(d.ruled_out_count || d.rejects.length));
        det.appendChild(el('summary', null, d.ruled_out_label || T('finder.ruled_out_n', { n: d.rejects.length })));
        var ul = el('ul', 'rr-plan__list');
        d.rejects.forEach(function (r) {
          var li = el('li');
          li.appendChild(el('strong', null, r.name + (r.count > 1 ? ' (x' + r.count + ')' : '') + ': '));
          li.appendChild(el('span', null, r.reason));
          ul.appendChild(li);
        });
        det.appendChild(ul);
        out.appendChild(det);
      }
      var next = el('a', 'rr-plan__btn rr-plan__btn--ghost', d.bike_hint ? T('finder.start_bike') : T('finder.start'));
      /* F1104-1232hv (newcomer walk R1): "Not sure? Start a diagnosis" opens the chat diagnosis like every other entry; only the bike
         hint keeps this repair-plan page, the one place that takes a model name (?bike=) */
      next.href = d.bike_hint && q ? '/pages/diagnose?view=repair-plan&bike=' + encodeURIComponent(q) : '/pages/diagnose';
      next.setAttribute('data-rr-start', '');
      out.appendChild(next);
    }
    var q0 = qs('q');
    if (q0) { input.value = q0; search(); }
  }

  function boot() {
    document.querySelectorAll('[data-rr-plan="repair"]').forEach(initRepair);
    document.querySelectorAll('[data-rr-plan="finder"]').forEach(initFinder);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
